// extracted by LIB_CSS_EXTRACT_LOADER
import "./slider_module.css"
export default {"root":"root-gCyNUT","control":"control-cXEMBl","track":"track-LybfXu","indicator":"indicator-AfXSd_","thumb":"thumb-NOPJuS"};